import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function FeatureSection({
  label,
  heading,
  description: subHeading,
  supportItems,
}) {
  return (
    <Container section margin>
      <Heading
        label={label}
        title={heading}
        subtitle={subHeading}
        decoration="line"
      />
      {supportItems && (
        <ul className="mt-12 grid grid-cols-1 gap-x-20 gap-y-10 lg:grid-cols-3">
          {supportItems.map((props, index) => (
            <Item key={index} {...props} />
          ))}
        </ul>
      )}
    </Container>
  )
}

function Item({ description, image }) {
  return (
    <li>
      <Image src={image} />
      <h3 className="mt-6 text-2xl font-bold">{description}</h3>
    </li>
  )
}

FeatureSection.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  supportItems: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      image: PropTypes.shape({}),
    })
  ),
}

export default FeatureSection

export const query = graphql`
  fragment FeatureSection on ContentfulFeatureSection {
    id
    __typename
    label
    heading
    description
    supportItems {
      title
      description
      image {
        gatsbyImageData(quality: 100, width: 720, placeholder: BLURRED)
        description
      }
    }
  }
`
